import { PropsWithChildren } from "react";
import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarGroup, MessageBarTitle, Spinner, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular,
    DismissRegular
} from "@fluentui/react-icons";
import { ILoadingSpinnerProps } from "./loading-spinner.props";
import ApiErrorBar from "../api-error-bar/api-error-bar";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";

const layoutStyles = makeStyles({
    mainWrapper: {
        ...shorthands.margin('2em'),
    }
});

export default function LoadingSpinner(props: ILoadingSpinnerProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    if (!props.loading)
        return (<></>);

    return (
        <div className={styles.mainWrapper}>
            <Spinner
                labelPosition="below"
                label={t('loading')} />
        </div>
    );
}